<template>
  <div class="aside-container">
    <el-menu
      :default-active="activeMenuPath || '/dashboard'"
      class="el-menu-vertical-demo"
      background-color="#273238"
      text-color="#839096"
      active-text-color="#fff"
    >
      <div v-for="(fItem, fIndex) in menus" :key="'f' + fIndex">
        <el-menu-item v-if="!fItem.children && !fItem.hidden" :index="fItem.path" @click="gotoPage(fItem.path)">
          <i :class="fItem.icon" />
          <span slot="title">{{ fItem.label }}</span>
        </el-menu-item>

        <el-submenu v-else-if="fItem.children && !fItem.hidden" :index="fItem.path">
          <template slot="title">
            <i :class="fItem.icon" />
            <span>{{ fItem.label }}</span>
          </template>
          <template v-for="(sItem, sIndex) in fItem.children">
            <el-menu-item
              v-if="!sItem.hidden"
              :key="'s' + sIndex"
              :index="sItem.path"
              @click="gotoPage(sItem.path)"
            >
              <span slot="title">{{ sItem.label }}</span>
            </el-menu-item>
          </template>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
import router from '@/router'
import { getLoginInfo } from '@/api/index'
export default {
  name: 'Aside',
  data() {
    return {
      menus: []
    }
  },
  computed: {
    activeMenuPath() {
      if (!this.menus.length) { return false }
      const defaultActive = this.menus.map(item => {
        return item.children ? item.children : item
      }).flat(1).filter(item => {
        if (this.$route.path.indexOf(item.path) >= 0) {
          return item
        }
      })[0].path
      return defaultActive
    }
  },
  mounted() {
    this.getMenus()
  },
  methods: {
    getMenus() {
      this.menus = router.options.routes.filter(item => {
        if (item.children) {
          return item.children
        }
      })[0].children
      this.getLoginInfoData()
    },

    getLoginInfoData() {
      getLoginInfo().then((res) => {
        if (res.data.role.indexOf(1) !== -1) {
          this.$store.commit('admin', true)
          this.menus[1].hidden = false
        } else {
          this.$store.commit('admin', false)
          this.menus[1].hidden = true
        }
      })
    },

    gotoPage(path) {
      this.$store.commit('setPath', path)
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/env";
.aside-container{
  height: $mainHeight;
}

.el-menu-item,
.el-submenu {
  width: $asideWidth;
}

::v-deep .el-menu-item-group__title {
  padding: 0;
}

.el-menu-item-group .el-menu-item {
  padding-left: 50px !important;
}

::v-deep li ul .el-submenu .el-submenu__title {
  padding-left: 50px !important;
}

::v-deep li ul .el-submenu .el-menu .el-menu-item {
  padding-left: 80px !important;
}

::v-deep .el-menu-item.is-active {
  background-color: rgba(10, 67, 133, 1)!important;
}
</style>
